import React from "react";
import { motion } from "framer-motion";
import ProjectsCard from './ProjectsCard';
import {projectEight} from "../../assets/index";
//import RapportDeProjetCovid from '../../assets/reports/RapportDeProjetCovid.pdf';
//import RapportProjetSondage from '../../assets/reports/RapportProjetSondage.pdf';

const OpenSource = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-6 font-titleFont flex flex-col gap-20 md:flex-row"
    >
      <div className="flex-1">
        <div className="py-6 font-titleFont flex flex-col gap-4">
          <h2 className="text-4xl font-bold">Open Source</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
          <ProjectsCard
            title="Floutage Automatique de Visages dans des Vidéos (Open CV)."
            des={`Contribution à un projet open source visant à centraliser des scripts Python d'automatisation. J’y ai développé un module permettant de flouter automatiquement des visages sélectionnés dans des vidéos.

              🔹 Technologies : Python, OpenCV, Numpy
              `}
            src={projectEight}
            githubLink="https://github.com/ChrisEssomba/Python-Scripts/tree/new-script/Real-Time-Face-Blurring-Tool"
            websiteLink="https://github.com/ChrisEssomba/Python-Scripts/tree/new-script/Real-Time-Face-Blurring-Tool"
          />
         
        </div>
      </div>
    </motion.div>
  );
};

export default OpenSource;